<template>
  <div>
    <v-toolbar color="primary" flat dark height="50px">
      <v-icon>ballot</v-icon>
        <v-toolbar-title>
          <span class="text-xs-right ml-2">{{ status }} Projects List</span>
        </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- Toolbar Button non-mobile -->
      <!-- <v-flex class="text-xs-right"> -->
        <v-toolbar-items>
          <!-- <v-btn :to="'/reports/projectsummary/' + status" outline>Project Summary</v-btn> -->
          <v-btn class="green" v-if="user.permissions.others.createCompletedProjects && status === 'Construction'" @click="createProjectDialog = true"><v-icon left>add</v-icon>Add Completed Project</v-btn>
          <v-btn class="primary" @click="showFilters = true"><v-icon left>{{isFilterActive ? 'done_all' : 'filter_list'}}</v-icon>Filter Results</v-btn>
          <v-btn class="orange" @click="refreshData"><v-icon left>cached</v-icon>Refresh Data</v-btn>
        </v-toolbar-items>
      <!-- </v-flex> -->
      <!-- Toolbar Button mobile -->
      <v-flex v-if="permissions.create" hidden-sm-and-up class="text-xs-right">
        <v-btn icon accent class="primary" @click="addNewProjectDialog = true">
          <v-icon>add</v-icon>
        </v-btn>
      </v-flex>
    </v-toolbar>
    <v-card>
      <v-card-title>
        <v-layout row wrap>
          <v-flex sm8 xs12>
            <!-- <v-btn class="primary" @click="showInactive = !showInactive; showStatusChange(status)"><v-icon left>{{showInactive ? 'visibility_off' : 'visibility'}}</v-icon>{{showInactive ? 'Hide Completed' : 'Show Completed'}}</v-btn> -->
            <v-btn class="primary" @click="showAssigned = !showAssigned"><v-icon left>person</v-icon>{{showAssigned ? 'Hide Assigned' : 'Show Assigned'}}</v-btn>
            <v-btn v-if="isFilterActive" dark class="orange" @click="resetFilters">Reset Filters</v-btn>
          </v-flex>
        <!-- End: Filter Pills -->
        <!-- Search Box -->
          <v-flex sm4 xs12>
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="search" label="Search Current List" single-line hide-details></v-text-field>
          </v-flex>
        </v-layout>
        <!-- End: Search Box -->
        <!-- Table Contents -->
      </v-card-title>
      <!-- <v-card-title>
        <v-flex xs4>
          <v-select v-model="userFilter" :items="getAllUsersNames" label="Filter By Users" clearable dense outlined multiple chips @change="getProjects()"></v-select>
        </v-flex>
      </v-card-title> -->
      <v-data-table v-if="projects" :headers="headers" :loading="loading" :rows-per-page-items="[10,25,50,100,{'text':'All','value':-1}]" :items="projects" :search="search" :item-key="projects.id" hide-actions>
        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <span slot="activator">{{ props.header.text }}</span>
            <span>{{ props.header.text }}</span>
          </v-tooltip>
        </template>
        <template slot="items" slot-scope="props">
          <tr>
          <td class="tableRow hidden-xs-only" @click="selectProject(props.item.id)">
            <v-layout row>
              <v-icon left>today</v-icon>
              <v-layout row wrap>
                <v-flex ml-3>{{ props.item.start_date | moment("from") }}</v-flex>
                <v-flex xs12 caption ml-3>{{ props.item.start_date | moment("dddd, MMMM Do YYYY") }}</v-flex>
              </v-layout>
            </v-layout>
          </td>
          <td class="tableRow" style="text-align: right" @click="selectProject(props.item.id)">
            <v-layout row>
              <v-layout row wrap>
                <v-flex ml-3>{{ props.item.job_number ? '#' + props.item.job_number : '' }}</v-flex>
              </v-layout>
            </v-layout>
          </td>
          <td class="tableRow" @click="selectProject(props.item.id)">
            <v-layout row>
              <v-icon>ballot</v-icon>
              <v-layout row wrap>
                <v-flex ml-3>{{ props.item.name }}</v-flex>
                <v-flex xs12 caption ml-3>{{ props.item.address }} {{ props.item.city }}, {{ props.item.state }} {{ props.item.zip }}</v-flex>
              </v-layout>
            </v-layout>
          </td>
          <!-- Progress Bar -->
          <td @click="selectProject(props.item.id)" class="hidden-xs-only">
            <v-layout row>
              <v-layout row wrap>
                <v-flex v-if="props.item.pastDueTasks && props.item.status !== 'Completed'" xs12 class="body-1">
                  <v-icon size="20px" class="ml-2" color="red">error</v-icon><span class="red--text ml-1">{{props.item.pastDueTasks}} Past Due Tasks</span>
                </v-flex>
                <v-flex xs12 caption>
                  <div v-if="props.item.status !== 'Completed'" class="w3-light-grey w3-round-xlarge" style="width:100%">
                    <div class="w3-container w3-round-xlarge" :class="props.item.progress === 0 ? 'w3-clear' : 'w3-blue'" :style="getProgress(props.item.progress)">{{props.item.progress + '%'}}</div>
                  </div>
                  <div v-if="props.item.status === 'Completed'">
                    <span class="subheading">Completed</span>
                  </div>
                </v-flex>
              </v-layout>
            </v-layout>
          </td>
          <!-- <td @click="" style="padding:0; font-size:20px!important"> -->
          <!-- Assigned Users -->
          <td class="hidden-xs-only" v-if="showAssigned">
            <v-layout row wrap>
              <v-tooltip top v-for="(assigned, index) in props.item.assigned_to" :key="index">
                <span>{{assigned.first_name + ' ' + assigned.last_name}}</span>
                <v-avatar slot="activator" style="cursor: pointer">
                  <avatar :username="assigned.first_name + ' ' + assigned.last_name" :src="assigned.avatar ? assigned.avatar : undefined"></avatar>
              </v-avatar>
              </v-tooltip>
            </v-layout>
          </td>
          <!-- End: Assigned Users -->
          <td class="justify-center layout px-0">
            <v-icon v-if="permissions.delete.all || (permissions.delete.assigned && props.item.assigned)" medium @click="deleteProject(props.item)">delete</v-icon>
          </td>
          </tr>
        </template>
      </v-data-table>
      <!-- End: Table Contents -->
    </v-card>
    <!-- Create Project Dialog -->
    <v-dialog max-width="800px" persistent v-model="createProjectDialog">
      <create-project v-if="createProjectDialog" @createContact="createContact" @closeDialog="createProjectDialog = false" :completedProject="true" :completedContact="completedContact"/>
    </v-dialog>
    <!-- End: Create Project Dialog -->
    <!-- Create Contact Dialog -->
    <v-dialog max-width="800px" persistent v-model="createContactDialog">
      <create-contact v-if="createContactDialog" @closeDialog="createContactDialog = false" :completedProject="true" @sendToProject="sendToProject"/>
    </v-dialog>
    <!-- End: Create Contact Dialog -->
      <!-- Filter Dialog Box -->
    <v-dialog v-if="showFilters" v-model="showFilters" width="800px" persistent>
      <filter-dialog @cancel-dialog="showFilters = false" @execute-filters="refreshData" :currentView="currentView"></filter-dialog>
    </v-dialog>
  </div>
</template>

<script>
  import { db } from '../../firebaseInit'
  import CreateProject from './CreateProject'
  import CreateContact from '../contacts/CreateContact'
  import Avatar from 'vue-avatar'
  import FilterDialog from '../dialogs/FilterDialog.vue'
  import _ from 'lodash'
  // import { db } from '../../firebaseInit'

  export default {
    props: ['status'],
    data () {
      return {
        showFilters: false,
        // projects: null,
        userFilter: null,
        completedContact: null,
        showAssigned: false,
        addNewProjectDialog: false,
        showInactive: false,
        // selectedContactId: null,
        // currentContact: null,
        activate: false,
        projectTest: 'Loading...',
        showCard: null,
        createProjectDialog: false,
        createContactDialog: false,
        search: null,
        projectFilterDialog: false,
        projectFilter: false,
        projectFilters: [],
        showAllProjects: false,
        showActiveProjects: true,
        showInactiveProjects: false,
        filterChange: false,
        validationRequired: [
          v => !!v || 'Field is required'
        ]
      }
    },
    created () {
      if (this.$store.getters.filteredTasks.length === 0 || this.$store.getters.currentView !== this.status) {
        this.$store.commit('currentView', this.status === 'Pre-Construction' ? 'preConstruction' : 'construction')
        this.refreshData()
      }
    },
    // created () {
    //   this.$store.commit('currentView', this.status)
    // },
    computed: {
      isFilterActive () {
        const defaultFilters = this.$store.getters.defaultFilters[this.currentView]
        const currentFilters = this.$store.getters.taskFilters[this.currentView]
        return !_.isEqual(defaultFilters, currentFilters)
      },
      currentView () {
        return this.status === 'Pre-Construction' ? 'preConstruction' : 'construction'
      },
      taskFilters () {
        return this.$store.getters.taskFilters
      },
      user () {
        return this.$store.getters.user
      },
      userList () {
        return _.orderBy(this.$store.getters.userList, 'first_name')
      },
      userNames () {
        return this.userList.filter(f => f.if_sales_rep === true).map(m => m.first_name + ' ' + m.last_name)
      },
      getAllUsersNames () {
        return this.userList.map(m => m.first_name + ' ' + m.last_name)
      },
      headers () {
        if (this.showAssigned) {
          return [ { text: 'Start Date', class: ['hidden-xs-only'], value: 'start_date' },
            { text: 'Job Number', align: 'right', value: 'job_number' },
            { text: 'Project', align: 'left', value: 'name' },
            { text: 'Progress', class: ['hidden-xs-only'], value: 'progress' },
            { text: 'Assigned', class: ['hidden-xs-only'], value: 'assigned' },
            { text: 'Delete', class: ['hidden-xs-only'], value: 'delete' },
            // Hidden Headers Used For Search
            { text: 'city', class: ['hidden-sm-and-up', 'hidden-xs-only'], value: 'city' }
          ]
        } else {
          return [ { text: 'Start Date', class: ['hidden-xs-only'], value: 'start_date' },
            { text: 'Job Number', align: 'right', value: 'job_number' },
            { text: 'Project', align: 'left', value: 'name' },
            { text: 'Progress', class: ['hidden-xs-only'], value: 'progress' },
            { text: 'Delete', class: ['hidden-xs-only'], value: 'delete' },
            // Hidden Headers Used For Search
            { text: 'city', class: ['hidden-sm-and-up', 'hidden-xs-only'], value: 'city' }
          ]
        }
      },
      permissions () {
        return this.$store.getters.user.permissions.projects
      },
      loading () {
        return this.$store.getters.loading
      },
      projects () {
        let getProjects = this.$store.getters.filteredTasks
        const userList = this.$store.getters.userList
        getProjects.forEach((project, i) => {
          let assignedUsers = []
          if (project.assigned_to && project.assigned_to.length > 0) {
            project.assigned_to.forEach(assigned => {
              assignedUsers.push(userList.filter(f => f.id === assigned)[0])
            })
            getProjects[i].assigned_to = assignedUsers
          }
        })
        // If waiting_on_template... Set Progress to 0
        getProjects = getProjects.map(m => ({ ...m, progress: m.waiting_on_template ? 0 : m.progress }))
        // Filter Completed vs Active
        console.log('getProjects', getProjects)
        return getProjects
      }
    },
    methods: {
      resetFilters () {
        this.$store.dispatch('loadDefaultFilters')
        this.$store.dispatch('saveUserFilters', { [this.currentView]: this.$store.getters.defaultFilters[this.currentView] })
        setTimeout(this.refreshData, 1000)
      },
      refreshData () {
        this.showFilters = false
        this.$store.dispatch('clearFilteredTasks')
        this.$store.dispatch('getFilteredTasks')
      },
      // getProjects () {
      //   let filteredProjects = []
      //   let getProjects = this.$store.getters.projectList
      //   // let getProjects = this.$store.getters.filteredTasks
      //   let userIds = []
      //   if (this.userFilter && this.userFilter.length > 0) {
      //     this.userFilter.forEach(user => {
      //       userIds.push(this.userList.filter(f => f.first_name + ' ' + f.last_name === user)[0].id)
      //     })
      //     getProjects.forEach(project => {
      //       let includeProject = false
      //       project.assigned_to.forEach(assigned => {
      //         if (userIds.includes(assigned.id)) {
      //           includeProject = true
      //         }
      //       })
      //       if (includeProject === true) {
      //         filteredProjects.push(project)
      //       }
      //     })
      //   } else {
      //     filteredProjects = Object.assign(getProjects)
      //   }
      //   let projects = []
      //   // Filter Completed vs Active
      //   filteredProjects.forEach(project => {
      //     let totalTasks = 0
      //     let completedTasks = 0
      //     let pastDueTasks = 0
      //     if (project.tasks && !project.revertedToLeads && !project.waiting_on_template) {
      //       const taskIds = Object.keys(project.tasks)
      //       totalTasks = taskIds.length
      //       taskIds.forEach(task => {
      //         if (project.tasks[task].status === 'Completed' || project.tasks[task].status === 'Not Applicable') {
      //           completedTasks++
      //         }
      //         if (project.tasks[task].due_date && project.tasks[task].status !== 'Completed' && project.tasks[task].status !== 'Not Applicable' && project.tasks[task].due_date.seconds < new Date().getTime() / 1000) {
      //           pastDueTasks++
      //         }
      //       })
      //       const progress = totalTasks === 0 || completedTasks === 0 ? 0 : Math.round(completedTasks / totalTasks * 100)
      //       projects.push({...project, totalTasks, completedTasks, pastDueTasks, progress})
      //     } else if (!project.revertedToLeads) {
      //       projects.push({...project, totalTasks: 0, completedTasks: 0, progress: 0, pastDueTasks: 0})
      //     }
      //   })
      //   // this.projects = projects
      //   // return projects
      //   this.projects = projects
      // },
      sendToProject (contactId) {
        let name = null
        let contactRecord = null
        db.collection('contacts').doc(contactId).get().then(contact => {
          if (contact.data().secondaryContact_first_name) {
            name = contact.data().first_name + ' ' + contact.data().last_name + ' and ' + contact.data().secondaryContact_first_name + ' ' + contact.data().secondaryContact_last_name
          } else {
            name = contact.data().first_name + ' ' + contact.data().last_name
          }
          contactRecord = contact.data()
        }).then(() => {
          this.createProjectDialog = true
          this.completedContact = {...contactRecord, id: contactId, name: name}
        })
      },
      forNewCustomer () {
        this.addNewProjectDialog = false
        this.createContactDialog = true
      },
      // forExistingCustomer () {
      //   this.addNewProjectDialog = false
      //   this.createProjectDialog = true
      // },
      showStatusChange (status) {
        if (this.showInactive) {
          this.$store.dispatch('getProjectList', {status: 'Completed', tasks: false}).then(() => { this.getProjects() })
        } else {
          this.$store.dispatch('getProjectList', {status: status, tasks: false}).then(() => { this.getProjects() })
        }
      },
      getProgress (progress) {
        return 'width: ' + progress + '%'
      },
      createContact () {
        this.createProjectDialog = false
        this.createContactDialog = true
      },
      selectProject (projectId) {
        this.$router.push('/project/' + projectId)
      },
      deleteProject (item) {
        confirm('Are you sure you want to delete the project ' + item.name + '?') && this.$store.dispatch('deleteProject', item).then(() => { this.getProjects() })
      }
    },
    components: {
      CreateProject,
      Avatar,
      CreateContact,
      FilterDialog
    }
  }
</script>

<style scoped>
.header {
  float: left;
  margin-bottom: 40px;
}
.hideHeader {
  color: red;
}
.createButton {
  float: right;
}
table.table tbody td {
  cursor: pointer;
  font-size: 20px;
  padding-left: 0px;
}
.tableRow {
  cursor: pointer;
  font-size: 20px;
  text-align: left;
  padding-right: 0px;
}
.avatar {
  display: flex;
}
/* .icon {
    margin-right: 10px;
  } */
.metrics {
  margin-bottom: 0px !important;
}
.w3-light-grey,
.w3-hover-light-grey:hover,
.w3-light-gray,
.w3-hover-light-gray:hover {
  color: #000 !important;
  background-color: #f1f1f1 !important;
  width: 100%;
}
.w3-round-xlarge {
  border-radius: 16px;
}
.w3-blue,
.w3-hover-blue:hover {
  color: #fff !important;
  background-color: #2196f3 !important;
}
.w3-clear,
.w3-hover-clear:hover {
  color: #000 !important;
  background-color: #fff !important;
}
.w3-container,
.w3-panel {
  padding: 0.01em 16px;
}
.w3-round-xlarge {
  border-radius: 16px;
}
tr {
  padding: 0px !important;
}
table.v-table {
  font-size: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/projects/ProjectList.vue